import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})

export class GiveawayService {
	private apiUrl = environment.API_URL;

	constructor(private http: HttpClient) {
	}

	get(guid?: string): Observable<any> {
		var url = `${this.apiUrl}/k1mobile/giveaway/${guid}`;
		return this.http.get(url);
	}
}